import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import TimelineQuote from 'components/layout/client/timelineComponents/TimelineQuote';

class TimelineQuoteAccepted extends React.Component {
  render() {
    const { intl, event } = this.props;
    const messages = intl.messages;

    return (
      <div class="card-block">
        <div style={{ position: 'absolute' }}>
          <i class="fa fa-check-circle-o fa-2x" />
        </div>
        <div class="p-l-55">
          <p>{messages.events.TimelineQuoteAccepted}</p>

          <TimelineQuote event={event} />
        </div>
      </div>
    );
  }
}
TimelineQuoteAccepted.propTypes = {
  event: PropTypes.object,
};

export default injectIntl(TimelineQuoteAccepted);
